const MediaDisplay = ({ file, index, total, scale }) => {
    
    const getImgSrc = (path) => {
        if (!path) return null;
        return path.startsWith("http") ? path : "/upload/" + path;
    };

    const isVideo = (path) => path?.match(/\.(mp4|webm|ogg)$/i);

    const mediaStyle = {
        transform: `scale(${scale})`,
        transition: "transform 0.3s ease",
        cursor: scale > 1 ? "grab" : "default",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain"
    };

    if (!file) {
        return <div className="centerContent"><span style={{ color: 'white' }}>Media not found.</span></div>;
    }

    return (
        <div className="centerContent">
            {isVideo(file) ? (
                <video
                    src={getImgSrc(file)}
                    controls
                    autoPlay
                    className="mediaItem"
                />
            ) : (
                <img
                    src={getImgSrc(file)}
                    alt={`Media ${index + 1}`}
                    className="mediaItem"
                    style={mediaStyle}
                />
            )}

            {total > 1 && (
                <div className="mediaCounter">
                    {index + 1} / {total}
                </div>
            )}
        </div>
    );
};
export default MediaDisplay;